"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Verification/SidebarNotice.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _session = require('shared/selectors/session');
var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');
var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);



var _BroadcastsVerification = require('web/components/Upsells/BroadcastsVerification');







/**
 * The verification lock in the campaign list. On narrow screens the list is
 * all that shows until a campaign is opened, so the request lives here too.
 */
const SidebarNotice = ({ isRequested, isRequesting, onRequest }) => {
  const orgKey = _hooks.useAppSelector.call(void 0, _session.selectSelectedOrgKey)
  const amIAdmin = _hooks.useAppSelector.call(void 0, state => !!orgKey && _user.selectAmIAdminInOrg.call(void 0, state, orgKey))
  const hint = _BroadcastsVerification.verificationHint.call(void 0, amIAdmin, isRequested)
  return (
    _react2.default.createElement('div', { className: "list-menu--upsells", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
      , _react2.default.createElement(_WarningBar2.default, { className: "list-menu--upsells--warning", text: _BroadcastsVerification.VERIFICATION_LOCKED_TITLE, __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}} )
      ,  hint && _react2.default.createElement('span', { className: "list-menu--upsells--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}},  hint ) 
      ,  amIAdmin && !isRequested && (
        _react2.default.createElement('button', {
          type: "button",
          className: "list-menu--upsells--access-link",
          onClick: onRequest,
          disabled: isRequesting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
, "Request verification"

        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, SidebarNotice)
